module.exports = __webpack_public_path__ + "static/1-1dda24c132f47c6180c76633910c115e.jpg";